<div class="card-white blue-dark noMarginMovil">
  <b class="mb-3">{{ 'k002886' | translate }}</b>
  <!-- Token: Cartera modelo al detalle -->
  <tech-loading-peq class="flex-container-row w-100" *ngIf="loadingMpTable">
  </tech-loading-peq>
  <div class="flex-container-row mt-1 mt-4 mb-2" *ngIf="!loadingMpTable">
    <!--OJO!!! Se ha pedido que la columna del + no sea visible pero que se mantenga el responsive
      Para eso metemos la clase noPlusColumn en la data-grid que pone le spna plus a display none-->

    <dx-data-grid
      id="gridDocProvider"
      class="noPlusColumn"
      [columns]="colsMpTable"
      [dataSource]="dataMpTable"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [rowAlternationEnabled]="true"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="false"
      [paging]="false"
    >
      <!-- Desactiva cualquier tipo de ordenación -->
      <dxo-sorting mode="none"></dxo-sorting>
      <!-- Plantillas para celdas con html en el interior -->
      <div class="w-100 barWeight" *dxTemplate="let row of 'templateWeight'">
        <span
          [style.width.%]="row.data.weight * 100"
          [style.background-color]="barColor(row)"
        ></span>
      </div>
    </dx-data-grid>
  </div>
</div>
